import React from 'react';

import { Chart } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  registerables as registerablesJS,
} from 'chart.js';
ChartJS.register(...registerablesJS);
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '72%',
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 10,
        boxHeight: 10,
        color: '#667085',
        padding: 14,
        usePointStyle: true,
        pointStyle: 'circle',
      },
    },
    title: {
      display: false,
    },
    tooltip: {
      backgroundColor: '#172033',
      padding: 12,
      callbacks: {
        label: (context) =>
          `${context.label}: ${new Intl.NumberFormat('vi-VN').format(Number(context.raw || 0))}đ`,
      },
    },
  },
};

const DebitChart = ({ data }) => {
  const dataChart = {
    labels: ['Phải thu', 'Phải trả'],
    datasets: [
      {
        label: 'Công nợ',
        data: [data?.total_debit_receive || 0, data?.total_debit_payment || 0],
        backgroundColor: ['#ed3237', '#2563eb'],
        borderWidth: 0,
        hoverOffset: 6,
      },
    ],
  };
  return <Chart type='doughnut' options={options} data={dataChart} />;
};

export default DebitChart;
